var _defs, _path, _polygon, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.71,1,4.69,6.7a2,2,0,0,0-1.06.82,2,2,0,0,0,.61,2.76L10,14h0l12.7-12.7A1,1,0,0,0,21.71,1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-0",
    points: "17.3 19.32 17.3 19.32 22.98 2.29 22.98 2.29 17.3 19.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,1.66a.94.94,0,0,0-.25-.39L10,14l3.69,5.79a2,2,0,0,0,1,.82,2,2,0,0,0,2.53-1.26L23,2.29A1,1,0,0,0,23,1.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.2,15.38,1.55,21A1,1,0,0,0,3,22.45L8.62,16.8A1,1,0,1,0,7.2,15.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.81,12.84,1.26,15.38A1,1,0,0,0,2.68,16.8l2.54-2.55a1,1,0,0,0,0-1.41A1,1,0,0,0,3.81,12.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.75,18.78,7.2,21.32a1,1,0,1,0,1.42,1.42l2.54-2.55a1,1,0,1,0-1.41-1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseInactive);
export default __webpack_public_path__ + "static/media/release-inactive.e5a02f35b13a528f037b46188ffd4145.svg";
export { ForwardRef as ReactComponent };